<template>
  <div class="wrapper">
    <div class="search-input-wrapper">
      <!-- <div class="search-wrapper">
        <img class="search-btn" src="/static/img/search.png" alt>
        <input class="search-input" type="text" placeholder="关键字搜索">
      </div>-->
      <div class="nav-wrapper">
        <span>当前位置：</span>
        <span class="active" @click="toPage({name:'Search'})">搜索</span>
        <span class="padd">&#62;</span>
        <span class>详情页</span>
      </div>
    </div>
    <div class="detail">
      <item-detail :detail="detail"></item-detail>
    </div>
  </div>
</template>
<style scoped>
.wrapper {
  width: 1230px;
  margin: 0 auto;
}
.detail {
  margin-top: 30px;
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color: #e6ecf2;
  padding: 40px 30px;
  box-sizing: border-box;
  border-radius: 10px;
}
.search-input-wrapper {
  display: flex;
}
.search-wrapper {
  width: 310px;
  margin-right: 30px;
  height: 40px;
  background: rgba(237, 241, 244, 1);
  border: 1px solid rgba(220, 227, 233, 1);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
}
.search-btn {
  width: 25px;
  height: 26px;
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
}
.search-input::placeholder {
  color: #a2a8b8;
}
.search-input {
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  background: rgba(237, 241, 244, 1);
}
.nav-wrapper {
  flex: 1;
}
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
</style>

<script>
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detail: {}
    };
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    getDetail() {
      userApi.getnewDeatil({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    itemDetail
  },
  mounted() {
    this.getDetail();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Search/searchDetail.vue